import { HealthReminder, MedicationReminder } from 'features/profile/types';
import { WellframeApi } from 'store/api';

export const remindersService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getMedicationReminders: builder.query<MedicationReminder[], void>({
      query: () => '/api/v3/medication_schedules',
    }),
    getHealthReminders: builder.query<HealthReminder[], void>({
      query: () => '/api/v3/reminders',
    }),
  }),
});

export const { useGetMedicationRemindersQuery, useGetHealthRemindersQuery } = remindersService;
